// src/store/slices/modeloSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../actions/configApi';

export const fetchProductBySku = createAsyncThunk(
    'vitrini/fetchProduct',
    async (sku, { rejectWithValue }) => {
        try {
            const response = await api.get(`productDetails/${sku}`); // Inclua a página na URL
            // const response = await api.get('modeloAll');
            console.log(response.data,  'productDetails');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || 'Erro ao carregar vitrini');
        }
    }
);
//estoque
export const incluirNoEstoque = createAsyncThunk(
    'estoque/incluirNoEstoque',
    async (avaliacao, { rejectWithValue }) => {
        try {
            const response = await api.post('estoque', avaliacao); // Altere a URL conforme necessário
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erro ao incluir no estoque');
        }
    }
);

const vitrineSlice = createSlice({
    name: 'vitrini',
    initialState: {
        produto: [],
        loading: false,
        loading2: false,
        message:'',
        error: null,
        error2: null,

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductBySku.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductBySku.fulfilled, (state, action) => {
                state.loading = false;
                state.produto = action.payload.produto;
            })
            .addCase(fetchProductBySku.rejected, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            //incluir produto
            .addCase(incluirNoEstoque.pending, (state) => {
                state.loading2 = true;
            })
            .addCase(incluirNoEstoque.fulfilled, (state, action) => {
                state.loading2 = false;
                state.produto = action.payload.produto;
                state.message = action.payload.message;
            })
            .addCase(incluirNoEstoque.rejected, (state, action) => {
                state.loading2 = false;
                state.error2 = action.payload;
            });

    },
});

export default vitrineSlice.reducer;
